import { render, staticRenderFns } from "./intro-management.vue?vue&type=template&id=254f817a&scoped=true"
import script from "./intro-management.vue?vue&type=script&lang=js"
export * from "./intro-management.vue?vue&type=script&lang=js"
import style0 from "./intro-management.vue?vue&type=style&index=0&id=254f817a&prod&lang=less&scoped=true"
import style1 from "./intro-management.vue?vue&type=style&index=1&id=254f817a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254f817a",
  null
  
)

export default component.exports